import React, { useEffect } from "react";
import { object, number } from "prop-types";

import StoryHeader from "../story-header";
import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";

import "./listcle.m.css";

const ListcleStoryTemplate = ({ story, index }) => {
  useEffect(() => {
    const storyCards = Array.from(document.querySelectorAll(".story-card"))
      .filter((card) => card.querySelector(".story-element-title"))
      .map((card, index) => {
        card.setAttribute("id", index + 1);
        return card;
      });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((card) => {
          if (card.intersectionRatio >= 0.05) {
            window.history.replaceState(null, null, `#${card.target.id}`);
          }
        });
      },
      {
        threshold: 0.05
      }
    );

    storyCards.forEach((card) => {
      observer.observe(card);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} />
            <StoryElements story={story} cards={story.cards} index={index} isPodcast />
          </div>
        </div>

        <div className="side-story-section hide-mobile">
          <StorySideBar index={index} story={story} />
        </div>
      </div>
    </>
  );
};

ListcleStoryTemplate.propTypes = {
  story: object,
  index: number
};

const ListcleStory = (props) => {
  return <ListcleStoryTemplate story={props.story} index={props.index} />;
};

ListcleStory.propTypes = {
  story: object,
  index: number
};

export default ListcleStory;
